import { useEffect, useState } from "react";
import Box from '@mui/material/Box'
import theme from "../../helpers/theme";
import { backendGetRequest } from "../../helpers/callBackend";
import { toPrice } from "../../helpers/stringFormat";
import { documentTitle } from "../header/documentTitle";
import { backendPost } from "../../helpers/callBackend";
import OpenedBankAccount from "./openedAccount/index";
import OuterBox from "../generic/arpariBoxes/OuterBox";


const AccountView = (props) => {
	const [bankAccountData, setBankAccountData] = useState({});
	useEffect(() => {
		const bankAccountId = window.location.pathname.split("/bank-accounts/details/000")[1];
		backendPost("/api/bank-account/update-cache/", { accountId: bankAccountId }, true, true);
	}, [props.viewType]);

	useEffect(() => {
		const bankAccountName = bankAccountData?.account?.bank_account_name || "";
		if (bankAccountName.length > 0) {
			documentTitle({ title: bankAccountName });
		} else {
			documentTitle();
		}
	}, [bankAccountData?.account]);

	const fetchBankAccountData = (bankAccountId, quick_get = false) => {
		backendGetRequest("/api/bank-account/", { params: { bank_account_id: bankAccountId, quick_get: quick_get } }, "loading").then((res) => {
			const d = res?.data;
			setBankAccountData(d);
		});
	}

	useEffect(() => {
		const bankAccountId = window.location.pathname.split("/bank-accounts/details/000")[1];
		fetchBankAccountData(bankAccountId, true);
		fetchBankAccountData(bankAccountId, false);
	}, [props.accountOwnerType, props.viewType]);

	const showVirtualDebitCard = (cardId) => {
		setBankAccountData((state) => ({
			...state,
			account: {
				...state.account,
				virtual_debit_card_info: {
					...state.account.virtual_debit_card_info,
					virtual_debit_card_available: true,
					virtual_debit_card_enabled: true,
					virtual_debit_card_details: {
						...state.account.virtual_debit_card_info.virtual_debit_card_details,
						card_id: cardId,
					},
				},
			},
		}));
	};

	const sendingFunds = (transaction) => {
		let floatBalance = transaction.balance / 100;
		const newBalance = parseFloat(floatBalance).toLocaleString("en-US", {
			style: "currency",
			currency: "USD",
		});

		setBankAccountData((state) => ({
			...state,
			account: {
				...state.account,
				available_balance: newBalance,
				current_balance: newBalance,
				aggregated_balance: newBalance,
			},
		}));
	};

	const updateBankAccountData = (data) => {
		setBankAccountData((state) => ({
			...state,
			account: {
				...state.account,
				account_type: data.account_type,
				account_name: data.account_name,
				bank_account_name: data.description,
				bank_address: data.bank?.address,
				current_balance: toPrice(data.last_current_balance),
				available_balance: toPrice(data.last_current_balance),
				aggregated_balance: toPrice(data.last_aggregated_balance),
				current_balance_raw_base_currency: data.current_balance_raw,
				available_balance_raw_base_currency: data.last_available_balance,
				aggregated_balance_raw_base_currency: data.aggregated_balance_raw,
				account_description: data.account_description,
				bank_name: data.bank?.name,
			},
			beneficiary: {
				...state.beneficiary,
				name: data.beneficiary_name,
				address: data.beneficiary_address_one_liner,
			},
		})
		);
	};

	return (

		<OuterBox>
			<Box sx={{ margin: theme.dashboard.margins }}>
				<OpenedBankAccount
					bankAccountInfo={bankAccountData?.account}
					beneficiaryInfo={bankAccountData?.beneficiary}
					bankAccountId={bankAccountData?.id}
					genericTags={bankAccountData?.generic_tags || []}
					purpose={bankAccountData?.purpose || {}}
					updateBankAccountData={updateBankAccountData}
					showVirtualDebitCard={showVirtualDebitCard}
					sendingFunds={sendingFunds}
					setBankAccountData={(data) => setBankAccountData(data)}
				/>
			</Box>
		</OuterBox>
	);
};

export default AccountView;